<script>
import { required } from 'vuelidate/lib/validators'

import axios from 'axios'


export default {
	props: {
		url: {
			type: String,
			default: '/pan/xdr/report/service',
		}
	},
	data() {
		return {
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Service',
					active: true,
				},
			],
			incidents: [],
			tableData: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: 'reference',
			sortDesc: true,
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			fields: [
				{ key: 'incident_id', label: 'ID', sortable: true },
				{ key: 'severity', sortable: true },
				{ key: 'status', sortable: true, thClass: 'incident-status' },
				{ key: 'description', sortable: false },
				{ key: 'alert_count', label: 'Alerts', sortable: true },
				{ key: 'creation_to_modification_minutes', label: 'Time (min)', sortable: true },
				{ key: 'creation_time', sortable: true },
				{ key: 'creation_to_now_minutes', sortable: true },
				{ key: 'modification_time', sortable: true },
				{ key: 'modification_to_now_minutes', sortable: true },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		/**
		 * Total no. of records
		 */
		rows() {
			return this.tableData.length
		},
	},
	mounted () {
		this.loadData()
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		loadData () {
			let that = this
			that.isBusy = true
			// if (process.env.NODE_ENV === 'production' && that.$store.state.id_token === undefined) return
			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
			axios.get(`${baseURL}${that.url}`).then((response) => {
				if (response.status === 200) {
					that.tableData = response.data.data.map(function(entry){
						return {
							incident_id: entry.incident_id,
							status: entry.status,
							severity: entry.severity,
							description: entry.description,
							manual_severity: entry.manual_severity,
							alert_count: entry.alert_count,
							creation_time:  new Date(entry.creation_time['$date']).toLocaleString(),
							modification_time: new Date(entry.modification_time['$date']).toLocaleString(),
							creation_to_now_minutes: entry.creation_to_now_minutes,
							modification_to_now_minutes: entry.modification_to_now_minutes,
							creation_to_modification_minutes: entry.creation_to_modification_minutes
						}
					})
				}		
				that.totalRows = that.tableData.length
				that.isBusy = false
			})
			.catch(function (error) {
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			}) 
			that.totalRows = that.tableData.length
		},
	},
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Found: 
					<b>
						{{ totalRows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						Search:
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="perPage"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:filter="filter"
				:filter-included-fields="filterOn"
				@filtered="onFiltered"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>
				<template v-slot:cell(severity)="data">
					<template v-if="data.item.severity === 'low'">
						<feather type="alert-circle" class="icon-xs icon-dual-success"></feather>
					</template>
					<template v-else-if="data.item.severity === 'medium'">
						<feather type="alert-triangle" class="icon-xs icon-dual-warning"></feather>
					</template>
					<template v-else>
						<feather type="alert-octagon" class="icon-xs icon-dual-danger"></feather>
					</template>
				</template>
				<template v-slot:cell(status)="data">
					<template v-if="data.item.status === 'new'">
						<span style="color:red;">
							<i class="uil uil-comment-plus font-size-15" />&nbsp;New
						</span>
					</template>
					<template v-else-if="data.item.status === 'closed'">
						<feather type="stop-circle" class="icon-xs icon-dual"></feather>
						Closed
					</template>
					<template v-else-if="data.item.status === 'under_investigation'">
						<span style="color:blue;">
							<i class="uil uil-comment-search font-size-15" />&nbsp;Under Investigation
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_threat_handled'">
						<span style="color:green;">
							<i class="uil uil-comment-shield font-size-15" />&nbsp;Resolved - Handled
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_true_positive'">
						<span style="color:green;">
							<i class="uil uil-comment-slash font-size-15" />&nbsp;Resolved - T.Positive
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_false_positive'">
						<span style="color:green;">
							<i class="uil uil-comment-slash font-size-15" />&nbsp;Resolved - F.Positive
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_other'">
						<span style="color:green;">
							<i class="uil uil-comment-dots font-size-15" />&nbsp;Resolved - Other
						</span>
					</template>
				</template>
				<template v-slot:cell(action)="data">
					<span>ℹ️</span>
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>